var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column GSE-color-background-darker GSE-appendix-sidebar"},[_c('FilterHeader',{attrs:{"filterStore":_vm.filterStore,"filters":{ year: false }}}),_vm._v(" "),_c('CategoriesFilter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }